<template>
  <div>
    <div class="pt-8 lg:px-20 md:px-20 px-5">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item class="fsize16">Resources</el-breadcrumb-item>
        <el-breadcrumb-item class="fsize16">Videos</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="lg:px-20 md:px-12 px-5 lg:py-12 md:py-12 py-5">
      <div class="lg:flex md:flex gap-9">
        <div class="w-60per sm-wfull">
          <p class="clr4F0A4B font-semibold">Watch New Videos</p>

          <p class="py-1">{{ allEpisode.playlistId.name }}</p>
          <p
            class="fsize32 md-fsize28 sm-fsize20 font-semibold clr-black lg:leading-10 md:leading-10 leading-8"
          >
            {{ allEpisode.title }}
          </p>
          <p class="py-2 sm-fsize14">
            {{ allEpisode.description }}
          </p>
          <p class="font-semibold pt-2 sm-fsize14">
            {{
              new Date(allEpisode.createdAt).toLocaleDateString(undefined, {
                year: "numeric",
                month: "long",
                day: "numeric",
              })
            }}
          </p>
          <button
            class="flex gap-2 bg4F0A4B clr-fff p-2 rounded-full px-6 py-2 mt-4 sm-fsize14"
            @click="handleOpen(allEpisode.video_url, true, allEpisode._id)"
          >
            Play
            <feather-icon
              icon="PlayIcon"
              class="clr-fff sm-fsize14"
              svgClasses="lg:w-4 lg:h-4 md:w-4 md:h-4 w-3 h-3 mt-1"
            ></feather-icon>
          </button>
        </div>
        <div class="w-40per sm-wfull flex items-center">
          <!-- <iframe
          class="scrnht-250 w-full rounded-xl"
          :src="handleFrame(episodeDetails.video_url)"
          frameborder="1"
        ></iframe> -->
          <img
            class="scrnht-250 w-full h-320 rounded-xl object-cover"
            :src="handleFrame(allEpisode.video_url)"
            alt="img"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      allEpisode: {},
    };
  },
  methods: {
    async dataLoad() {
      let payload = {
        isBanner: true,
      };
      let { data } = await this.$store.dispatch(
        "playlist/getall_episode",
        payload
      );
      this.allEpisode = data.result[0];
    },
    handleFrame(url) {
      const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
      const match = url.match(regex);
      return `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg`;
    },
    handleRedirect(id) {
      this.$router.push({
        name: "channelpage",
        query: {
          cid: id,
        },
      });
    },
    async handleOpen(url, toRecent = false, id = "") {
      if (toRecent) {
        let payload = {
          episodeId: id,
        };
        try {
          await this.$store.dispatch("playlist/add_history", payload);
          this.dataLoad();
        } catch (error) {
          console.log(error);
        }
      }
      window.open(url, "_blank");
    },
  },
  computed: {
    ...mapState("playlist", {
      getAllHistory: "getAllHistory",
      getAllEpisode: "getAllEpisode",
    }),
    ...mapState("auth", { user: "user" }),
    // episodeData() {
    //   return this.getAllEpisode.result[0];
    // },
  },
  mounted() {
    this.dataLoad();
  },
};
</script>
